import { render, staticRenderFns } from "./standalone-text.vue?vue&type=template&id=6a41cc2a&scoped=true&"
import script from "./standalone-text.vue?vue&type=script&lang=js&"
export * from "./standalone-text.vue?vue&type=script&lang=js&"
import style0 from "./standalone-text.vue?vue&type=style&index=0&id=6a41cc2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a41cc2a",
  null
  
)

export default component.exports